export const DATE_VALIDATION_ERROR_MESSAGES = {
    disableFuture: 'It is not allowed to select date in the future',
    disablePast: 'It is not allowed to select date in the past',
    invalidDate: 'Provided date is invalid',
    maxDate: 'Provided date is later than the maximum allowed date',
    minDate: 'Provided date is earlier than the minimum allowed date',
    shouldDisableDate: 'Provided date cannot be selected',
};
export const DATE_RANGE_VALIDATION_ERROR_MESSAGES = Object.assign(Object.assign({}, DATE_VALIDATION_ERROR_MESSAGES), { invalidRange: 'Provided date range is invalid' });
//# sourceMappingURL=dates.constants.js.map